import { FC } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { isPublicNext } from "../next/public/mode";
import { rememberWantedPage } from "../utils/wantedPage";

/** A route guard's "not signed in" redirect. Public v3 (P2.5, new look): remembers the page that was wanted, so sign-in can go back to it. */
export const ToLogin: FC = () => {
  const { pathname, search } = useLocation();
  if (isPublicNext()) rememberWantedPage(pathname + search);
  return <Navigate to="/login" />;
};
